// extracted by mini-css-extract-plugin
export default {"container":"PaypalCheckout_container__xoB1u","paypal":"PaypalCheckout_paypal__jRJMq"};